<template>
    <div>
        <div
            v-if="$page.props.flash.success && show"
            class="alert alert-success rounded-0 mb-0 position-absolute w-100 z-100"
        >
            <div class="container">
                <div class="row">
                    <div class="col flex-grow-1">
                        <i class="far fa-check-circle"></i>
                        {{ $page.props.flash.success }}
                    </div>
                    <div class="col flex-grow-0">
                        <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="show = false"
                        >
                            <i class="fas fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div
            v-if="$page.props.flash.warning && show"
            class="alert alert-warning rounded-0 mb-0 position-absolute w-100 z-100"
        >
            <div class="container">
                <div class="row">
                    <div class="col flex-grow-1">
                        <i class="far fa-times-circle"></i>
                        {{ $page.props.flash.warning }}
                    </div>
                    <div class="col flex-grow-0">
                        <button
                            type="button"
                            class="btn btn-link p-0"
                            @click="show = false"
                        >
                            <i class="fas fa-times-circle"></i>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  data() {
    return {
      show: true,
      showErrors: false,
    };
  },
  watch: {
    '$page.props.flash': {
      handler() {
        this.show = true;
      },
      deep: true,
    },
  },
};
</script>
